import { useTranslation } from 'react-i18next';
import { H3 } from '../../../styles/FontStyles';
import { color } from '../../../styles/GlobalStyles';

export const AutoStakeTransactions = () => {
  const { t } = useTranslation('my_hubs');

  return (
    <div>
      <div>
        <H3 mb='20' center color={color.colors.secondary100}>
          {t('auto_stake')}
        </H3>
      </div>
    </div>
  );
};
